export enum PromotionalCampaignStatusId {
  Active = 1,
  Expired = 2,
  Cancelled = 3,
}
